export default __webpack_public_path__ + "static/media/Frostmist Cloak.aced38f6.jpg";